import EditTempPkomModal from './containers/EditTempPkomModal'

export default EditTempPkomModal
